type NetworkInformationLike = {
  type?: string;
  effectiveType?: string;
};

export type NetworkConnectionAtCapture = {
  connectionType: string | null;
  connectionEffectiveType: string | null;
};

/**
 * Reads Network Information API values at GPS evidence capture time.
 * Returns nulls when the API is unavailable or properties are missing.
 */
export function readNetworkConnectionAtCapture(): NetworkConnectionAtCapture {
  try {
    const connection = (navigator as Navigator & { connection?: NetworkInformationLike })
      .connection;
    return {
      connectionType: connection?.type ?? null,
      connectionEffectiveType: connection?.effectiveType ?? null,
    };
  } catch {
    return {
      connectionType: null,
      connectionEffectiveType: null,
    };
  }
}
